import { Image, Navbar } from "react-bootstrap";

const Header = () => {
  return (
    <Navbar
      className="px-3 px-sm-5 d-flex align-items-center text-truncate bg-white shadow fixed-top"
      style={{ height: "80px" }}
    >
      <Navbar.Brand className="h-100 py-1 fw-bold text-dark">
        <Image
          className="h-100 me-1"
          src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/Logo_ODO-removebg-preview 1.svg`}
          alt="Logo Icon"
        />
        Web Application Service & Maintenances Interface SAP Business One
      </Navbar.Brand>
    </Navbar>
  );
};

export default Header;
